import React, { FC } from 'react';
import styles from './chatLoader.module.scss';

export const ChatLoader: FC = () => {
    return (
        <div data-testid="chat-loader" className={styles.container}>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};
